// Shopify Cart Script - Remove specific products if minimum cart value not met

class ShopifyCartManager {
  constructor() {
    // Products with minimum cart value requirements (in cents)
    this.minValueProducts = [
      { id: '9386674094375', min: 69900 },   // Min ₹699
      { id: '9386678681895', min: 99900 },   // Min ₹999
      { id: '10098268176679', min: 119900 }  // Min ₹1199
    ];
    
    // Set to track all 3 variant IDs for easy checking
    this.restrictedVariantIds = new Set(['9386674094375', '9386678681895', '10098268176679']);
  }

  // Main function to process the cart
  async processCart() {
    try {
      // Get current cart
      const cart = await this.getCart();
      
      if (!cart || !cart.items || cart.items.length === 0) {
        console.log('Cart is empty');
        return;
      }

      // Get cart total (Shopify already calculates this with any discounts applied)
      const cartTotal = cart.total_price; // This includes BOGO discounts if applied
      
      console.log(`Cart total: ₹${cartTotal / 100}`);
      
      // Check which products need to be removed
      const itemsToRemove = [];
      
      cart.items.forEach(item => {
        const variantId = item.variant_id.toString();
        const productRule = this.minValueProducts.find(p => p.id === variantId);
        
        // Only check our 3 specific products
        if (productRule) {
          // Remove ONLY if cart total is below minimum (ignore price since freebies are always ₹0)
          if (cartTotal < productRule.min) {
            console.log(`Removing variant ${variantId}: Cart total ₹${cartTotal/100} is below minimum ₹${productRule.min/100}`);
            itemsToRemove.push(item);
          }
        }
      });
      
      // Remove items if needed
      if (itemsToRemove.length > 0) {
        await this.removeItems(itemsToRemove);
        console.log(`Removed ${itemsToRemove.length} items from cart`);
        
        // Refresh the page to show updated cart
        window.location.reload();
      }
      
      return {
        success: true,
        cartTotal: cartTotal,
        itemsRemoved: itemsToRemove.length
      };
      
    } catch (error) {
      console.error('Error processing cart:', error);
      return { success: false, error: error.message };
    }
  }

  // Get current cart via Shopify Cart API
  async getCart() {
    const response = await fetch('/cart.js');
    return await response.json();
  }

  // Remove items from cart
  async removeItems(items) {
    const updates = {};
    
    items.forEach(item => {
      updates[item.key] = 0; // Set quantity to 0 to remove
    });
    
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates })
    });
    
    return await response.json();
  }
}

// Initialize cart manager
const cartManager = new ShopifyCartManager();

// Run on page load
document.addEventListener('DOMContentLoaded', function() {
  cartManager.processCart();
});

// Intercept all cart API calls (add, update, change)
const originalFetch = window.fetch;
window.fetch = function(...args) {
  const url = args[0];
  
  // Check if it's a cart-related API call
  if (typeof url === 'string' && 
      (url.includes('/cart/add.js') || 
       url.includes('/cart/update.js') || 
       url.includes('/cart/change.js'))) {
    
    return originalFetch.apply(this, args).then(response => {
      const clonedResponse = response.clone();
      
      // Process cart after the API call completes
      setTimeout(() => {
        cartManager.processCart();
      }, 300);
      
      return clonedResponse;
    });
  }
  
  return originalFetch.apply(this, args);
};